"use client";

import Link from "next/link";
import { ArrowRight } from "lucide-react";

type Props = {
  title?: string;
  subtitle?: string;
  ctaText?: string;
};

export function MarketingCta({
  title = "Ready to find your next opportunity?",
  subtitle = "Join other job seekers who've streamlined their search with HireFit.",
  ctaText = "Sign up or Login",
}: Props) {
  return (
    <section className="bg-linear-to-br from-[#1c3d51] via-[#2b4276] to-[#1F5867] px-4 py-16 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-3xl text-center">
        <h2 className="mb-4 text-2xl font-bold text-white md:text-3xl">{title}</h2>
        <p className="mb-8 text-lg text-[#bedcee]">{subtitle}</p>
        <Link
          href="/login"
          className="group inline-flex items-center gap-2 rounded-lg bg-[#2a9695] px-6 py-3 text-white hover:bg-[#78d0d0] hover:text-[#1c3d51]"
        >
          {ctaText}
          <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
        </Link>
      </div>
    </section>
  );
}
